import { render, staticRenderFns } from "./SubmissionSingle.vue?vue&type=template&id=ec858e92"
import script from "./SubmissionSingle.vue?vue&type=script&lang=js"
export * from "./SubmissionSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports